export const NavigateToLanding = () => {
  let url = window.location.origin;
  url = `${url}/landing`;
  window.location.replace(url);
};

export const NavigateNullMsisdn = () => {
  const data = getCookie("data");
  if (!data?.msisdn) {
    let url = window.location.origin;
    url = `${url}/landing`;
    window.location.replace(url);
  }
};

export const LogoutUser = () => {
  clearAllCookies();
  NavigateToLanding();
};
export const setCookie = (msisdn, token, subscribeId) => {
  clearAllCookies();
  let data = {
    msisdn: msisdn,
    token: token,
    subscribeId: subscribeId,
  };
  const maxAge = 30 * 24 * 60 * 60;
  document.cookie = `data=${encodeURIComponent(
    JSON.stringify(data)
  )}; SameSite=Strict; path=/; max-age=${maxAge}`;
};

export const getCookie = (name) => {
  try {
    // console.log("document.cookie", document.cookie);
    const cookies = document.cookie.split(";").reduce((acc, cookie) => {
      const [key, value] = cookie.split("=");
      // console.log("key", key);
      // console.log("value", value);
      acc[key.trim()] = decodeURIComponent(value);
      return acc;
    }, {});
    // console.log("cookies[name]", JSON.parse(cookies[name]));
    return cookies[name] ? JSON.parse(cookies[name]) : null;
  } catch (e) {
    console.log("error", e);
    return null;
  }
};
export const clearAllCookies = () => {
  document.cookie.split(";").forEach((cookie) => {
    document.cookie = cookie
      .replace(/^ +/, "")
      .replace(/=.*/, "=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;");
  });
};

export const logout = (val) => {
  clearAllCookies();
  if (val === "network") {
    // window.location.href = '/landing'
  }
};

export const getDataFromCookies = () => {
  const data = getCookie("data");
  return {
    cookieMsisdn: data?.msisdn || null,
    cookieSubscribeId: data?.subscribeId || null,
  };
};
export const getQueryParams = (param) => {
  if (typeof window !== "undefined") {
    const urlParams = new URLSearchParams(window.location.search);
    return urlParams.get(param);
  }
  return null;
};
